import { HollowedButton, NormalButton } from '@shared/designSystem/Button';
import { HorizontalContainer, VerticalContainer } from '@shared/designSystem/Containers';
import { Modal } from '@shared/designSystem/messages/Modal';
import { BoldText, SmallText, Text } from '@shared/designSystem/Texts';
import designSystemStyles from '@shared/styles/designSystemStyles';
import { PilotCatalogTableRow } from './PilotOnboardingTableViewModel';

interface PilotOnboardingConvertModalScreenProps {
    isOpen: boolean;
    pilot: PilotCatalogTableRow | null;
    isConverting: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const PilotOnboardingConvertModalScreen: React.FC<PilotOnboardingConvertModalScreenProps> = ({
    isOpen,
    pilot,
    isConverting,
    onClose,
    onConfirm,
}) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={"Convertir piloto a cliente".localized()}
            width="620px"
            maxWidth="90vw"
        >
            <VerticalContainer gap={designSystemStyles.gapLg}>
                <VerticalContainer gap={designSystemStyles.gapSm}>
                    <BoldText text={"¿Seguro que quieres convertir este piloto a cliente?".localized()} />
                    <Text text={"La organizacion dejara de aparecer en el listado de pilotos y pasara a ser un cliente activo.".localized()} />
                </VerticalContainer>

                {pilot && (
                    <VerticalContainer
                        padding={designSystemStyles.paddingMd}
                        backgroundColor={designSystemStyles.colorBackgroundGray3}
                        borderRadius={designSystemStyles.cornerRadiusComponent}
                        gap={designSystemStyles.gapSm}
                    >
                        <SmallText text={"ID".localized()} />
                        <BoldText text={pilot.id} />
                        <SmallText text={"Nombre".localized()} />
                        <Text text={pilot.name} />
                    </VerticalContainer>
                )}

                <HorizontalContainer justifyContent="flex-end" gap={designSystemStyles.gapMd}>
                    <HollowedButton
                        text={"Cancelar".localized()}
                        onClick={onClose}
                        disabled={isConverting}
                        width="180px"
                    />
                    <NormalButton
                        text={"Convertir a cliente".localized()}
                        onClick={onConfirm}
                        loading={isConverting}
                        disabled={!pilot}
                        width="180px"
                    />
                </HorizontalContainer>
            </VerticalContainer>
        </Modal>
    );
};

export default PilotOnboardingConvertModalScreen;
